import { render } from "./SelecionarEstoqueProdutoMovimento.vue?vue&type=template&id=96c34cea&scoped=true&ts=true"
import script from "./SelecionarEstoqueProdutoMovimento.vue?vue&type=script&lang=ts"
export * from "./SelecionarEstoqueProdutoMovimento.vue?vue&type=script&lang=ts"

import "./SelecionarEstoqueProdutoMovimento.vue?vue&type=style&index=0&id=96c34cea&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c34cea"]])

export default __exports__